import React, { useEffect, useState } from 'react';
import cn from 'clsx';

import { useMediaQuery } from '../../../../shared/hooks/hooks';

import styles from './sticky-footer.scss';

interface StickyFooterProps {
  className?: string;
  isAlwaysSticky?: boolean;
}

function StickyFooter(props: React.PropsWithChildren<StickyFooterProps>) {
  const { children, className = '', isAlwaysSticky = false } = props;
  const [tempMutation, setTempMutation] = useState('');
  const breakponts = useMediaQuery();
  const containerStyleName = isAlwaysSticky ? 'sticky-container' : 'container';

  useEffect(() => {
    // TODO: OW-16054 - Find a better way to move accessibility button above sticky elements, without having to mutate the sticky element.
    setTimeout(() => {
      if (breakponts.isMinMd) {
        setTempMutation(`md`);
      } else if (breakponts.isMinSm) {
        setTempMutation(`sm`);
      } else if (breakponts.isMinXxxs) {
        setTempMutation(`xs`);
      }
    }, 0);
  }, [breakponts]);

  return (
    <footer
      className={cn(styles[containerStyleName], `sticky-footer ${className}`)}
      data-mutation={tempMutation}
    >
      {children}
    </footer>
  );
}

export default StickyFooter;
